module.exports = __webpack_public_path__ + "img/new-4.fabd6bc3.png";